import { render, staticRenderFns } from "./DeckDetail.vue?vue&type=template&id=6e8e5591&scoped=true&"
import script from "./DeckDetail.vue?vue&type=script&lang=js&"
export * from "./DeckDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8e5591",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8e5591')) {
      api.createRecord('6e8e5591', component.options)
    } else {
      api.reload('6e8e5591', component.options)
    }
    module.hot.accept("./DeckDetail.vue?vue&type=template&id=6e8e5591&scoped=true&", function () {
      api.rerender('6e8e5591', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/cruise/deck/DeckDetail.vue"
export default component.exports